import styles from 'typescript/components/product_groups/color_selection.module.scss';

export const COLOR_SELECTION_DATA_TEST_ID = 'color-selection';
export const COLOR_SELECTION_SLASH_TEST_ID = 'color-selection-slash';

interface ColorSelectionProps {
  hexCode: string;
  state: 'in_stock' | 'out_of_stock';
  selected: boolean;
  onSelected?: () => void;
}

const ColorSelection = ({
  hexCode,
  state = 'in_stock',
  selected = false,
  onSelected,
}: ColorSelectionProps) => {
  const colorSelectionClass = ({
    state,
    selected,
  }: Pick<ColorSelectionProps, 'state' | 'selected'>): string => {
    const baseClass = styles.colorSelection;
    const classes = [baseClass];

    if (selected) {
      classes.push(
        state === 'in_stock'
          ? styles.colorSelectionInStockSelected
          : styles.colorSelectionOutOfStockSelected,
      );
    }

    return classes.join(' ');
  };

  return (
    <div
      role="button"
      data-testid={COLOR_SELECTION_DATA_TEST_ID}
      className={colorSelectionClass({ state, selected })}
      style={{
        backgroundColor: hexCode,
      }}
      onClick={onSelected}
    >
      {state === 'out_of_stock' && (
        <div
          data-testid={COLOR_SELECTION_SLASH_TEST_ID}
          className={styles.slash}
        />
      )}
    </div>
  );
};

export default ColorSelection;
